module.exports = __webpack_public_path__ + "img/logo.9cfb1fd1.jpg";